import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=79faafca&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=79faafca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79faafca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79faafca')) {
      api.createRecord('79faafca', component.options)
    } else {
      api.reload('79faafca', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=79faafca&scoped=true&", function () {
      api.rerender('79faafca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bRE5Hmmg3mpb/JS/comp/DocBox.vue"
export default component.exports